import CompanyTopicsTablesController from "./company-topics-table-controller";
import { connect } from "react-redux";
import { getValue } from "store/languages";
import { setRightMenuComponent, setShowRightMenu, setRemoveRightMenuComponent } from "store/side-bar";
import { getCompanyTopicsSelector, getCompanyAccountTopicsSelector } from "selectors/superadmin-selector";
import { getCompanyAccounts, getCompanyTopics, startTopic, pauseTopic, deleteCompanyTopic, setTopicId, attachTopicToAccount, detachTopicFromAccount, detachMarkerTopic, makeTopicVisibleToMarker, getTopicAccounts } from "store/superadmin";
import { getAccountsTable, getAccountsName } from "selectors/superadmin-selector";

let mapStateToProps = (state) => {
    return {
        company: state.superadmin.company,
        companyId: state.superadmin.companyId,
        companyTopics: getCompanyTopicsSelector(state, false),
        accountTopics: getCompanyAccountTopicsSelector(state, true),
        tableHeader: state.superadmin.tableHeader,
        topicsTableControlButtons: state.superadmin.topicsTableControlButtons,
        deletedTopicsTableControlButtons: state.superadmin.deletedTopicsTableControlButtons,
        accountsTopicTablerControlButton: state.superadmin.accountsTopicTablerControlButton,
        topicAccounts: getAccountsName(state),
        selectedAccounts: getAccountsName(state, true),
        accounts: getAccountsTable(state),
        accountId: state.superadmin.accountId,
        topicId: state.superadmin.topicId,
        isSuperadmin: state.Account.isSuperadmin,
        adminCompanyId: state.Account.companyId,
        markers: state.superadmin.markers,
        deviceType: state.header.deviceType,
        companyTopicsCount: state.superadmin.companyTopicsCount,
        page: state.superadmin.companyTopicsPage
    }
}

const CompanyTopicsTablesContainer = connect(mapStateToProps, {  
                                getValue,
                                startTopic, 
                                pauseTopic,
                                deleteCompanyTopic,
                                setRightMenuComponent, 
                                setShowRightMenu, 
                                setRemoveRightMenuComponent,
                                setTopicId,
                                attachTopicToAccount,
                                detachTopicFromAccount,
                                makeTopicVisibleToMarker,
                                detachMarkerTopic,
                                getTopicAccounts,
                                getCompanyAccounts, 
                                getCompanyTopics
                                })(CompanyTopicsTablesController)

export default CompanyTopicsTablesContainer